import { isTopLevelToolName } from "./surfaces-B1_F0pzt.js";

//#region src/internal/tool-helpers/tool-call-formatting.ts
function formatArgumentValue(value) {
	if (typeof value === "string") return `'${value.replaceAll("\\", "\\\\").replaceAll("'", "\\'")}'`;
	if (Array.isArray(value) || typeof value === "object") return JSON.stringify(value);
	return String(value);
}
function formatArguments(args) {
	return Object.entries(args).map(([key, value]) => `${key}=${formatArgumentValue(value)}`).join(", ");
}
function formatPurpose(purpose) {
	return purpose ? ` ${purpose}` : "";
}
/**
* Checks the actual session tool set; missing availability preserves legacy
* behavior for callers that cannot provide session-scoped tool metadata.
*/
function isToolAvailableInSession(toolName, availableToolNames) {
	return !availableToolNames || availableToolNames.has(toolName);
}
function isDirectTool(toolName, experimentalMode, directToolNames) {
	return directToolNames ? directToolNames.has(toolName) : isTopLevelToolName(toolName, experimentalMode);
}
function formatToolCall({ toolName, arguments: args = {} }) {
	const formattedArgs = formatArguments(args);
	return `${toolName}(${formattedArgs})`;
}
/**
* Formats user-facing tool guidance as a direct call, catalog gateway call, or
* fallback message based on the current session's available/direct tools.
*/
function formatToolCallInstruction({ toolName, arguments: _args = {}, experimentalMode, purpose, availableToolNames, directToolNames, fallbackInstruction }) {
	const targetAvailable = isToolAvailableInSession(toolName, availableToolNames);
	if (targetAvailable && isDirectTool(toolName, experimentalMode, directToolNames)) return `Use the Sentry tool \`${toolName}\`${formatPurpose(purpose)}`;
	const catalogGatewayAvailable = isToolAvailableInSession("search_sentry_tools", availableToolNames) && isToolAvailableInSession("execute_sentry_tool", availableToolNames) && isDirectTool("search_sentry_tools", experimentalMode, directToolNames) && isDirectTool("execute_sentry_tool", experimentalMode, directToolNames);
	if (targetAvailable && catalogGatewayAvailable) return `Use the Sentry tool \`${toolName}\`${formatPurpose(purpose)}`;
	return fallbackInstruction ?? `The Sentry tool \`${toolName}\` is not available in this session`;
}
/**
* Formats user-facing guidance only when the target tool is available in the
* current session; otherwise returns null so callers can omit the guidance.
*/
function formatAvailableToolCallInstruction({ toolName, experimentalMode, purpose, availableToolNames, directToolNames }) {
	if (!isToolAvailableInSession(toolName, availableToolNames)) return null;
	return formatToolCallInstruction({
		toolName,
		experimentalMode,
		purpose,
		availableToolNames,
		directToolNames
	});
}

//#endregion
export { formatAvailableToolCallInstruction, formatToolCall, formatToolCallInstruction, isToolAvailableInSession };
//# sourceMappingURL=tool-call-formatting-ALc98KqF.js.map